import { IOwnerLocation } from "modules/ownerLocations/domain/interfaces/IOwnerLocation";
import { getOwnerLocations } from "services/api/ownerLocations/OwnerLocationsApi";

export const FetchOwnerLocationUseCase = (): Promise<IOwnerLocation[]> => {
  return getOwnerLocations();
};
